import { Edit3, Loader, Printer, Save, View } from "lucide-react";
import React, { useState } from "react";
import RecieptDetails from "./RecieptDetails";

const SummaryTotalCard = ({
  totals,
  setAdwanceIsOn,
  adwanceIsOn,
  handlePrint,
  handleSave,
  recieptSection,
  setRecieptSection,
  receiptData,
  handleReceiptDataChange,
  paymentModes,
  onOpenModal,
  setAdvancePercentage,
  advancePercentage,
  advanceAmount,
  roundOff,
  setRoundOff,
  discountAmount,
  setDiscountAmount,
  setReceiptToggleManual,
  mode,
  autoVatIsOn,
  setVatAmountManual,
  BASE_URL,
  setCommissionAccounts,
  DEPARTMENT,
  config,
  setIsModificationModalOpen,
  showAdwance,
  isSaving,
  setAdvanceAmount,
}) => {
  return (
    <>
      <div className="bg-white rounded-lg shadow-lg border border-gray-200">
        <div className="p-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-blue-600 ">
              Summary & Totals
            </h3>
            <button
              onClick={onOpenModal}
              className="text-indigo-600 text-sm underline font-semibold hover:text-indigo-700 transition-colors flex items-center gap-2"
            >
              <Edit3 className="w-4 h-4" />
              More Fields
            </button>
          </div>
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2 w-full">
              <div className=" flex-1">
                <label className="block text-sm text-start font-medium text-gray-700 mb-1">
                  Taxable Amount
                </label>
                <input
                  type="text"
                  name="taxableAmt"
                  value={totals.taxableAmount}
                  readOnly
                  className="w-full  bg-gray-50 px-3 py-2 text-sm border border-gray-300 rounded-md text-right focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="flex-1">
                {" "}
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Gross Amount
                </label>
                <input
                  type="text"
                  name="grossAmount"
                  value={totals.grossAmount}
                  readOnly
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md text-right focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
            <div className="grid grid-cols-2 items-center gap-2">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  VAT Amount
                </label>
                <input
                  type="text"
                  name="vatAmt"
                  value={totals.vatAmount}
                  readOnly={autoVatIsOn}
                  onChange={(e) => {
                    if (!autoVatIsOn) {
                      const newVat = parseFloat(e.target.value) || 0;
                      setVatAmountManual(newVat);
                    }
                  }}
                  className={`w-full px-3 py-2 text-sm border border-gray-300 text-right rounded-md  focus:outline-none focus:ring-2 focus:ring-blue-500 ${!autoVatIsOn ? "" : "bg-gray-100"
                    }`}
                />
              </div>
              <div className="flex items-center gap-2 w-full">
                <div className="flex-1">
                  <label className="block text-xs text-gray-600 mb-1">
                    Disc Amount
                  </label>
                  <input
                    type="number"
                    name="discAmt"
                    value={discountAmount}
                    onChange={(e) => setDiscountAmount(e.target.value)}
                    // placeholder="Enter discount"
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md text-right focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div className="flex-1">
                  <label
                    title=" Round Off (-0.24 to 0.24)"
                    className="block text-xs text-gray-600 mb-1"
                  >
                    Round Off
                  </label>
                  <input
                    type="number"
                    name="Fills"
                    value={roundOff}
                    onChange={(e) => {
                      let val = e.target.value;
                      if (val === "" || val === "-") {
                        setRoundOff(val);
                        return;
                      }

                      const numVal = parseFloat(val);

                      if (isNaN(numVal)) return;

                      if (numVal < -0.24 || numVal > 0.24) {
                        alert("Please enter Fills between -0.24 to 0.24");
                        return;
                      }

                      setRoundOff(val);
                    }}
                    min={-0.24}
                    max={0.24}
                    step={0.01}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md text-right focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>{" "}
              </div>
            </div>
            <div>
              <div className="grid grid-cols-2 items-center gap-2">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    BC Amount
                  </label>
                  <input
                    type="text"
                    name="bcAmt"
                    value={totals.bcAmt}
                    readOnly
                    className="w-full px-3 py-2 text-sm border border-gray-300 text-right rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm text-end font-medium text-gray-700 mb-1">
                    Total Amount
                  </label>
                  <input
                    type="text"
                    name="total"
                    value={totals.totalAmount}
                    className="w-full px-3 py-2 text-sm font-bold border border-gray-300 rounded-md text-right bg-green-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            </div>{" "}
            {showAdwance && (
              <>
                <hr className="border-gray-200" />

                <div className="flex items-end gap-4">
                  {/* Toggle Section */}
                  <div className="min-w-[140px] p-2 border border-gray-200 rounded-md text-center bg-gray-50">
                    <span className="block text-xs text-gray-600">
                      Advance Is
                    </span>
                    <div className="flex items-center justify-center gap-2 mt-1">
                      <span
                        className={`text-sm font-medium ${adwanceIsOn ? "text-green-600" : "text-gray-500"
                          }`}
                      >
                        {adwanceIsOn ? "ON" : "OFF"}
                      </span>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={adwanceIsOn}
                          onChange={(e) => setAdwanceIsOn(e.target.checked)}
                          className="sr-only peer"
                        />
                        <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
                      </label>
                    </div>
                  </div>

                  {/* Fields Section */}
                  {adwanceIsOn && (
                    <div className="flex gap-2 flex-1">
                      <div className="flex-1">
                        <label className="block text-xs text-gray-600 mb-1">
                          Adv %
                        </label>
                        <input
                          type="number"
                          name="advPercentage"
                          value={advancePercentage}
                          min={0}
                          max={100}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow empty string or valid numbers
                            if (
                              value === "" ||
                              (!isNaN(value) &&
                                Number(value) >= 0 &&
                                Number(value) <= 100)
                            ) {
                              setAdvancePercentage(
                                value === "" ? "" : Number(value),
                              );
                            }
                          }}
                          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md text-right focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-xs text-gray-600 mb-1">
                          Advance
                        </label>
                        <input
                          type="text"
                          name="advanceAmount"
                          value={advanceAmount}
                          onChange={(e) =>
                            setAdvanceAmount(Number(e.target.value || 0))
                          }
                          // readOnly
                          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md text-right focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* Coloumn 3: Net amount */}
      <div>
        <>
          <div className="p-4 bg-white shadow border border-purple-200 rounded-lg text-center">
            <div className="text-sm text-gray-600 mb-1">Net Amount</div>
            <div className="text-2xl font-bold text-blue-600">
              {totals.netAmount}
            </div>
          </div>

          <div className="flex items-center lg:justify-end justify-center gap-3 mt-3">
            {config.features.showReceipt && (
              <div className="min-w-[120px] p-2.5 border border-gray-200 rounded-md text-center bg-gray-50">
                <div className="flex items-center justify-center gap-2 ">
                  <span className="block text-sm text-gray-600">
                    Receipt Card{" "}
                  </span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={recieptSection}
                      onChange={(e) => {
                        setReceiptToggleManual(true);
                        setRecieptSection(e.target.checked);
                      }}
                      className="sr-only peer"
                    />
                    <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
                  </label>
                </div>
              </div>
            )}
            {/* <button
              onClick={handlePrint}
              className="flex items-center gap-2 px-5 py-2.5  border border-indigo-600 text-indigo-600 text-sm font-medium rounded-lg shadow hover:bg-text-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <View className="w-4 h-4" />
              View
            </button> */}
            <button
              onClick={() => {
                if (mode === "edit") {
                  setIsModificationModalOpen(true);
                } else {
                  handleSave();
                }
              }}
              disabled={mode === "view" || isSaving}
              title={mode === "view" ? "Disabled in view mode" : ""}
              className="flex items-center gap-2 px-5 py-2.5 bg-green-500 text-white text-sm font-medium rounded-lg shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSaving ? (
                <>
                  <Loader className="w-4 h-4 animate-spin" />
                  Saving...
                </>
              ) : (
                <>
                  <Save className="w-4 h-4" />
                  {mode === "edit" ? "Update" : "Save"}
                </>
              )}
            </button>
          </div>
        </>

        {recieptSection && (
          <RecieptDetails
            recieptSection={true}
            data={receiptData}
            onChange={handleReceiptDataChange}
            totals={totals}
            paymentModes={paymentModes}
            BASE_URL={BASE_URL}
            setCommissionAccounts={setCommissionAccounts}
            DEPARTMENT={DEPARTMENT}
          />
        )}
      </div>
    </>
  );
};

export default SummaryTotalCard;
